import m = require("mithril");
import {VideoItem} from "../../model/items/video";
import {youTubePlayer} from "./video/youtube";
import {vimeoPlayer} from "./video/vimeo";

export function videoItemView(c:VideoItem) {
    return m('.video', {
        oncreate: vnode => {
            switch (c.type) {
                case "youtube":
                    youTubePlayer.show(c, vnode.dom);
                    break;
                case "vimeo":
                    vimeoPlayer.show(c, vnode.dom);
                    break;
                default:
                    // console.log("unknown video type");

            }
        }
    });
}
